export default {"src":"/_next/static/media/notification.837e4a9c.gif","height":640,"width":640,"blurWidth":0,"blurHeight":0};